import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

import Reset from './reset/update'
import Error from './error/error'
import Success from './success/success'

import {
  LAYOUT_PUBLIC_ACCESS_ERROR,
  LAYOUT_PUBLIC_ACCESS_RESET,
  LAYOUT_PUBLIC_ACCESS_ACCEPTED,
  LAYOUT_PUBLIC_ACCESS_SUCCESS
} from '../navigation'

const Routes = (props) => {
  return (
    <Switch>
      <Route path={LAYOUT_PUBLIC_ACCESS_ERROR} render={(routeProps) => <Error {...props} {...routeProps} />} />
      <Route
        path={LAYOUT_PUBLIC_ACCESS_SUCCESS}
        render={(routeProps) => <Success {...props} {...routeProps} />}
      />
      <Route
        path={LAYOUT_PUBLIC_ACCESS_ACCEPTED(':hash', '')}
        render={(routeProps) => <Reset {...props} {...routeProps} />}
      />
      <Route
        path={LAYOUT_PUBLIC_ACCESS_RESET(':hash', '')}
        render={(routeProps) => <Reset {...props} {...routeProps} />}
      />
      <Redirect to={LAYOUT_PUBLIC_ACCESS_ERROR} />
    </Switch>
  )
}

export default Routes
